<template>
  <div :class="size + type + classSelected + 'box-item'" @click="action(data)">
    <div v-if="type == 'backdrop '" class="backdrop__image-container">
      <img
        :src="
          image
            ? 'data:image/png;base64,' + image
            : require('@/assets/campanha-placeholder.png')
        "
        alt=""
      />
    </div>
    <img v-if="this.isSelected" ref="svgImage" :src="data.iconName ? require(`@/assets/services/${data.iconName}-white.svg`) : require('@/assets/services/business-finance-white.svg')" alt="" width="80px" height="80px"/>
    <img v-if="!this.isSelected && type != 'backdrop '" ref="svgImage" :src="data.iconName ? require(`@/assets/services/${data.iconName}.svg` ) : require('@/assets/services/business-finance.svg')" alt="" width="80px" height="80px"/>
    <Badge v-if="isPromo" label="Promo" />
    <div :class="type != 'backdrop ' ? 'text-container' : 'text-container-campaign'">
      <p class="text">
        <strong>
          {{ data.name }}
        </strong>
        <CheckIcon iconColor="#FFFFFF" />
      </p>
      <p v-if="data.description" class="text">
        {{ data.description }}
      </p>
    </div>
  </div>
</template>

<script>
import Badge from "@/components/Badge/Badge.vue";
import CheckIcon from "@/assets/icons/CheckIcon.vue";

export default {
  name: "Box",
  components: {
    Badge,
    CheckIcon,
  },
  props: {
    data: { type: Object, default: () => {} },
    isSelected: { type: [Boolean, Object], default: () => {} },
    size: { type: String, default: "" },
    type: { type: String, default: "" },
    isPromo: { type: Boolean, default: false },
    image: { type: String, default: "" },
  },
  data() {
    return {
      classSelected:
        this.isSelected == undefined || this.isSelected == false
          ? " "
          : " selected ",
    };
  },
  methods: {
    action(data) {
      this.$emit("action", data);
    },
  },
  watch: {
    isSelected() {
      this.classSelected =
        this.isSelected == undefined || this.isSelected == false
          ? " "
          : " selected ";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "/Box";
</style>
